import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/quotation_drafts',
    name: 'QuotationDraft',
    component: {
      name: 'AdminQuotationDrafts',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'quotation_draft',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminQuotationsDraftIndex',
        component: () => import('../views/QuotationsIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminQuotationDraftNew',
        component: () => import('../views/QuotationInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminQuotationsDraftIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminQuotationDraftShow',
        component: () => import('../views/QuotationShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminQuotationsDraftIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminQuotationDraftDetails',
            component: () => import('../views/QuotationDetails.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsDraftIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminQuotationDraftEdit',
            component: () => import('../views/QuotationInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminQuotationDraftDetails' },
            },
          },
          {
            path: 'send',
            name: 'AdminQuotationSend',
            component: () => import('../views/QuotationSend.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminQuotationIndex' },
              customName: 'views.quotation.approve',
            },
          },
          {
            path: 'attachments',
            name: 'AdminQuotationDraftAttachments',
            component: () => import('../views/attachment/QuotationAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsDraftIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'phases',
            name: 'AdminQuotationDraftPhases',
            component: () => import('../views/QuotationPhases.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsDraftIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminQuotationDraftLogs',
            component: () => import('../views/QuotationLogs.vue'),
            meta: {
              backRoute: { name: 'AdminQuotationsDraftIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));
